import { axiosFactory, errorHandler, currentPage } from '@/configs/axios'

const driverList = {
  api: (search) => {
    return axiosFactory()
      .auth.get(`drivers/${currentPage()}${search ? `?search=${search}` : ''}`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const driverSummary = {
  api: () => {
    return axiosFactory()
      .auth.get(`drivers/summaries/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const driverStatus = {
  api: () => {
    return axiosFactory()
      .auth.get('drivers/statuses/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const driverGenders = {
  api: () => {
    return axiosFactory()
      .auth.get('drivers/genders/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}
const driverEducation = {
  api: () => {
    return axiosFactory()
      .auth.get('drivers/educations/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}
const driverMartial = {
  api: () => {
    return axiosFactory()
      .auth.get('drivers/martial-statuses/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}
const driverBlood = {
  api: () => {
    return axiosFactory()
      .auth.get('drivers/blood-types/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const driverLicensetypes = {
  api: () => {
    return axiosFactory()
      .auth.get('drivers/license-types/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}
const getDriverLicensetype = {
  api: (payload) => {
    return axiosFactory()
      .auth.get('drivers/license-types/' + payload + '/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const removeDriver = {
  api: (payload) => {
    return axiosFactory()
      .auth.delete('drivers/' + payload + '/')
      .then((res) => {
        return true
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const getADriver = {
  api: (payload) => {
    return axiosFactory()
      .auth.get('drivers/' + payload + '/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const addDriver = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('drivers/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const editDriver = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('drivers/' + payload.id + '/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const getHealth = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`drivers/${payload}/information/healths/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        // errorHandler(error);
      })
  },
}

const addHealth = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('drivers/information/healths/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const editHealth = {
  api: (payload) => {
    return axiosFactory()
      .auth.put(`drivers/${payload.id}/information/healths/`, payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const getPro = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`drivers/${payload}/information/professionals/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        // errorHandler(error);
      })
  },
}

const addPro = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('drivers/information/professionals/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const editPro = {
  api: (payload) => {
    return axiosFactory()
      .auth.put(`drivers/${payload.id}/information/professionals/`, payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const getCompany = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`drivers/${payload}/information/companies/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        // errorHandler(error);
      })
  },
}

const addCompany = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('drivers/information/companies/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const editCompany = {
  api: (payload) => {
    return axiosFactory()
      .auth.put(`drivers/${payload.id}/information/companies/`, payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const behavioursDrivers = {
  api: (payload) => {
    return axiosFactory()
      .auth.get(`/stats/drivers/${payload[0]}/?date=${payload[1]}`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        return false
      })
  },
}

export const getDriverLeave = {
  api: (payload) => {
    return axiosFactory()
      .auth.get('drivers/leaves/' + payload + '/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const removeDriverLeave = {
  api: (payload) => {
    return axiosFactory()
      .auth.delete('drivers/leaves/' + payload + '/')
      .then((res) => {
        return true
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const driverLeaveList = {
  api: (search) => {
    return axiosFactory()
      .auth.get(
        `drivers/leaves/${currentPage()}${search ? `?search=${search}` : ''}`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const addDriverLeave = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('drivers/leaves/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const editDriverLeave = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('drivers/leaves/' + payload.id + '/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const driverLeaveType = {
  api: () => {
    return axiosFactory()
      .auth.get(`drivers/leave-types/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export {
  driverList,
  driverStatus,
  driverLicensetypes,
  getDriverLicensetype,
  removeDriver,
  getADriver,
  addDriver,
  editDriver,
  driverSummary,
  driverGenders,
  driverEducation,
  driverMartial,
  driverBlood,
  getHealth,
  addHealth,
  editHealth,
  getPro,
  addPro,
  editPro,
  getCompany,
  addCompany,
  editCompany,
  behavioursDrivers,
}
